import { article1 } from "./articles/simino-social-vs-buffer";
import { article2 } from "./articles/simino-social-vs-agorapulse";
import { article3 } from "./articles/simino-social-vs-eclincher";
import { article4 } from "./articles/simino-social-vs-hootsuite";
import { article5 } from "./articles/simino-social-vs-later";
import { article6 } from "./articles/simino-social-vs-loomly";
import { article7 } from "./articles/simino-social-vs-meta-business-suite";
import { article8 } from "./articles/simino-social-vs-metricool";
import { article9 } from "./articles/simino-social-vs-sked-social";
import { article10 } from "./articles/simino-social-vs-sprout-social";
import { article11 } from "./articles/simino-social-vs-tailwind";
import { article12 } from "./articles/ai-native-value-and-human-control";
import { leanEnterpriseArticle } from "./articles/lean-ai-native-human-led";

export const RESOURCE_ARTICLES = [article1, article2, article3, article4, article5, article6, article7, article8, article9, article10, article11, article12, leanEnterpriseArticle];
